import { connect } from 'react-redux';

import BuildPageChartContainer from './/BuildPageChartContainer.jsx';
import { getDurationMetricsInfo } from './../reducers';
import { unicode } from '../helpers';

export const mapStateToProps = (state) => {
  const metricsInfo = getDurationMetricsInfo(state);
  metricsInfo.metrics = metricsInfo.metrics.map(m => m.durationPercent);

  const props = {
    title: `Duration ${unicode.DELTA}%`,
    metricsInfo
  };
  return props;
};

export default connect(
  mapStateToProps
)(BuildPageChartContainer);


// WEBPACK FOOTER //
// src/Containers/DurationBarChartContainer.jsx